module.exports = __webpack_public_path__ + "pl.svg?d3ef7ce00af81ce1aabd4344c2c792ee";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/pl.svg
// module id = 1161
// module chunks = 27